import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    DispatchCompleteAddingProductToCart,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";

export type HandlerType = Parameters<typeof DispatchCompleteAddingProductToCart>[0];

addToChainAfter(chain, DispatchCompleteAddingProductToCart, SendAddLineTracking);

interface TransactionData {
    event: string;
    ecommerce: Ecommerce;
}

interface Ecommerce {
    currency: string;
    value: number;
    customer: string | undefined;
    items: { item_name: string; item_id: string; price?: number; quantity: number }[];
}

function getDataLayer() {
    return (window as any).dataLayer;
}

export function getCurrency(actualPriceDisplay: string | undefined) {
    if (actualPriceDisplay?.includes("$")) {
        return "USD";
    }
    return "EUR";
}

function SendAddLineTracking(props: HandlerType) {
    const state = props.getState();
    const { cartId } = state.pages.checkoutShipping;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);

    const billToState = getBillToState(state, cartState.value?.billToId);

    if (IS_SERVER_SIDE) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const data: TransactionData = {
        event: "add_to_cart",
        ecommerce: {
            currency: getCurrency(props.apiResult.pricing?.actualPriceDisplay),
            value: props.apiResult.pricing?.actualPrice ?? 0,
            customer: billToState?.value?.customerNumber,
            items: [
                {
                    item_id: props.apiResult.erpNumber,
                    item_name: props.apiResult.productName,
                    price: props.apiResult.pricing?.actualPrice,
                    quantity: props.apiResult.qtyOrdered ?? 0,
                },
            ],
        },
    };

    dataLayer.push(data);
}

export function sendAddToCartTracking(data: Ecommerce) {
    const dataLayer = getDataLayer();

    if (!dataLayer) {
        return;
    }

    const eventData: TransactionData = {
        event: "add_to_cart",
        ecommerce: data,
    };

    dataLayer.push(eventData);
}
